import { CloseOutlined } from "@ant-design/icons";
import { Modal, ModalProps } from "antd";
import React, { ReactNode } from "react";

interface AppModalWrapperProps extends ModalProps {
  headerStyle?: React.CSSProperties;
  closeIcon?: ReactNode;
  children?: ReactNode;
  title: string;
  titleImage?: string | any;
}
const AppModalWrapper: React.FC<AppModalWrapperProps> = ({
  headerStyle,
  closeIcon,
  children,
  title,
  titleImage,
  ...rest
}) => {
  const titleContent = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...headerStyle,
      }}
    >
      {titleImage && (
        <img src={titleImage} alt="Title" style={{ marginRight: "10px" }} />
      )}
      {title}
    </div>
  );
  return (
    <Modal
      {...rest}
      wrapClassName="twinge-health-modal"
      closeIcon={closeIcon || <CloseOutlined />}
      title={titleContent}
      footer={null}
      keyboard={false}
      maskClosable={false}
    >
      {children}
    </Modal>
  );
};
export default AppModalWrapper;
